import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterEmspBoTariffListContext } from '../../emsp-bo-tariff.context';
import { EmspBoTariffListFilterFormStep1Controller } from '../emsp-bo-tariff-list-filter-form-step-1/emsp-bo-tariff-list-filter-form-step-1.controller';

export interface EmspBoTariffListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetTariffsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetTariffsPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoTariffListFilterFormController = (
  props: EmspBoTariffListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterEmspBoTariffListContext();

  return (
    <MultiStepFormProvider<GetTariffsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: [
            'id',
            'cpoId',
            'createdAfter',
            'createdBefore',
            'updatedAfter',
            'updatedBefore',
          ],
          component: <EmspBoTariffListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
